var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrowback-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1666667,11.1641268 L4.92166667,11.1641268 L12.6466667,3.42499269 C12.9716667,3.09932779 12.9716667,2.56991357 12.6466667,2.24424867 C12.32,1.91858378 11.7933333,1.91858378 11.4683333,2.24424867 L2.195,11.5365538 C1.935,11.7970857 1.935,12.219615 2.195,12.480147 L11.4516667,21.7557513 C11.7766667,22.0814162 12.305,22.0814162 12.63,21.7557513 C12.955,21.4284164 12.955,20.9006722 12.63,20.5750073 L4.90666667,12.8342032 L21.1666667,12.8342032 C21.6266667,12.8342032 22,12.460106 22,11.999165 C22,11.539894 21.6266667,11.1641268 21.1666667,11.1641268",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c44334e2038ea9db3db6351ed41bf60c.svg";
export { ForwardRef as ReactComponent };